import { opaccAjaxPlugin } from '../opacc.static.js';

/** @module manager */

/**
 *  Nutzung von Cookies (Prüfen)
 */
export class OpaccCookie {
	constructor() {
		this.container = document.querySelector('.opc-manager-cookie');
		this.attachEventListener();
		this.sendAjaxRequest();
	}

	/**
	 * Event Registrierung im DOM
	 *
	 */
	attachEventListener() {
		if (this.container) {
			this.container.addEventListener('click', event => {
				if (event.target.classList.contains('opc-button')) {
					// Bei Klick auf "Akzeptieren", Trace zur Nachverfolgung speichern
                    let url = opaccAjaxPlugin.setAsyncUrl();
					opaccAjaxPlugin.fetchAsynPostForm(url, { crypt:this.container.getAttribute('data-op-crypt2') }, this.refreshContent.bind(this), this.getDefaultErrorFnc, true);
				}
			});
		}
	}

	/**
	 *
	 *
	 */
	sendAjaxRequest() {
		if (this.container && !this.cookieUsageAccepted()) {
			// Pruefen, ob die Nutzung von Cookies bereits akzeptiert wurde
            let url = opaccAjaxPlugin.setAsyncUrl();
			opaccAjaxPlugin.fetchAsynPostForm(url, { crypt:this.container.getAttribute('data-op-crypt1') }, this.refreshContent.bind(this), this.getDefaultErrorFnc, true);
		}
	}


	/**
	 *
	 *
	 * @returns {*}
	 */
	cookieUsageAccepted() {
		let decodedCookie = decodeURIComponent(document.cookie);
		let cookies = decodedCookie.split(';');
		for (const cookie of cookies) {
			if (cookie.trim() === 'CookieUsageConfirmed=true') {
				return true;
			}
		}
		return false;
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	refreshContent(response) {
		if (response.dataAsHtml) {
			this.container.innerHTML = response.dataAsHtml;
		}
		else {
			this.container.innerHTML = '';
		}
	}
}